import { Mui, omitReduxProps } from "@osu/react-ui";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { API_STATUS } from "../../util/constants";
import { useSelector } from "react-redux";
import { selectAuthenticationStatus } from "../../services/authorization/slices";
import { useState } from "react";
import { authorizationRoutes } from "../../Routes/paths";
import useRoleAuthentication from "../../Authentication/hooks/useRoleAuthentication";

function AuthButton(props = {}) {
  const { name, ...rest } = props;
  const remainingProps = omitReduxProps(rest);
  const status = useSelector(selectAuthenticationStatus)
  const [inOrOut, setInOrOut] = useState("In")
  const { pathname } = useLocation()
  const onAuthPage = [authorizationRoutes.login, authorizationRoutes.unauthorized].includes(pathname)
  const { user } = useRoleAuthentication();
  const keyboardFocusSx =  { ":focus-visible": { "outline": "2pt solid #0060df", "border-radius": "2px" } };

  if(onAuthPage) {
    return false
  }

  if (status === API_STATUS.LOADING) {
    return (
        <Mui.Box {...remainingProps} sx={{display: "flex", flexDirection: "row"}}>
          <Mui.CircularProgress className="margin-right-1"/>
          <Mui.Typography variant="body1" className="margin-top-1">
            {Boolean(inOrOut) && `Signing ${inOrOut}`}
          </Mui.Typography>
        </Mui.Box>
    );
  }

  if (status === API_STATUS.SUCCESS) {
    return (
      <>
        {user.name && (
            <>
                <Mui.Typography variant="body2" sx={ {"margin-left": "0.5rem" }}>{user.name}</Mui.Typography>
                <Mui.Typography variant="body2">&nbsp;&nbsp;|</Mui.Typography>
            </>
        )}
        <Mui.Button onClick={() => setInOrOut("Out")} variant="text" color="secondary" component={RouterLink} to="/logout" {...remainingProps} sx={keyboardFocusSx}>
          Sign Out
        </Mui.Button>
      </>
    );
  }

  return (
    <Mui.Button onClick={() => setInOrOut("In")} variant="outlined" component={RouterLink} to={"/login"} state={{
        redirectPath: pathname
      }} {...remainingProps} sx={keyboardFocusSx}>
      Sign In
    </Mui.Button>
  );
}

export default AuthButton;